export default {
  MAIN: 'main-page',
  REFUND: 'refund',
  RESULT: 'result',
  ERROR: 'error',
  NOT_FOUND: 'not_found'
}
